import { Injectable } from "@angular/core";
import { UserModel, SysconfigModel } from "../models/user.model";
import { LotteryModel } from "../models/lottery.model";
import { StorageService } from "../providers/storage.service";
import { Title } from "@angular/platform-browser";
import { NavController } from "ionic-angular";
import { WechatSettingModel } from "../models/wechat.model";
import { NativeAudio } from '@ionic-native/native-audio';
import { AlertService } from "../providers/alert.service";
import { InAppBrowser } from "@ionic-native/in-app-browser";
@Injectable()
export class AppConfig {
  constructor(
    private storage: StorageService,
    private titleService: Title,
    private nativeAudio: NativeAudio,
    private alert: AlertService,
    private iab: InAppBrowser,
  ) {
    this.nativeAudio.preloadSimple('uniqueId1', 'assets/mp3/sound/open.wav').then(() => {
      console.log('can vidio')
    }, () => {
      console.log('not can vidio')
    });


    this.nativeAudio.preloadSimple('uniqueId2', 'assets/mp3/guoan.mp3').then(() => {
      console.log('can vidio')
    }, () => {
      console.log('not can vidio')
    });

  }
  public static connected: boolean = false;
  public static User: UserModel;
  public static VrIsOpen: boolean = false;
  public static isShowNewMsg: boolean = true;
  public static downloadUrl: string = '';
  public static balanceTimer;
  public static peruserMoney: number = 0;
  public static markSixYear: number = new Date().getFullYear();
  public static markSixPrevYear: number = AppConfig.markSixYear - 1;
  public static markSixStartIssue: string = "";

  public getCurrentUser() {
    AppConfig.User = this.storage.read<UserModel>("User");
    return AppConfig.User;
  }

  //获取sysconfig
  //TQQ 2017-02-24
  public getSysConfig() {
    return this.storage.read<SysconfigModel>("sysconfig");
  }

  //获取lotterys
  //chen 2017-02-25
  public getLotterys() {
    return this.storage.read<LotteryModel[]>("lotterys");
  }

  /**
   * Base64加密
   * @param value 需要加密的数据
   */
  public static encodeBase64(value) {
    // return new Buffer(value).toString("base64");
    return btoa(encodeURIComponent(value).replace(/%([0-9A-F]{2})/g, (match, p1) => {
      return String.fromCharCode(parseInt(p1, 16));
    }));
  }

  /**
   * Base64解密
   * @param value 需要解密的数据
   */
  public static decodeBase64(value) {
    return new Buffer(value, "base64").toString();
  }

  //获取用户喜欢的彩种
  public getLikes() {
    return this.storage.read<LotteryModel[]>("likes") || [];
  }

  public GetWechatSettings() {
    return this.storage.read<WechatSettingModel>("wechatsettings");
  }

  public static GetProdUrl() {
    var aa = this.GetHostUrl();
    return this.GetHostUrl() + "/api";
  }

  public static GetUrl() {
    return this.GetHostUrl();
  }
  public static isWap: boolean = true;
  public static GetHostUrl() {
    // return "https://wap.xb377b.com";           // 新宝三正式区打包地址
    // return "http://xb3vswap.xinbao3.cc"
    //  return "http://xb3vsgame.xinbao3.cc"            //新3测试区
    // return "http://cb6bju.natappfree.cc";
    return "";
  }

  public static GetSignalrServerUrl() {
    return AppConfig.isWap
      ? "/signalr"
      : "https://signalr.xb386d.com/signalr"; // 新宝3正式区推送
  }

  //投注页计时
  //TQQ 2017-02-10
  public setIntervalid: any;

  //设置标题
  //TQQ 2017-02-15
  public setTitle(newTitle: string) {
    this.titleService.setTitle(newTitle);
  }

  public NavCtrl: NavController;

  //封单提示
  //TQQ 2017-02-25
  public createMp3() {
    // let mp3 = new Audio("assets/mp3/guoan.mp3");
    // mp3.play();
    // mp3.remove();


    this.nativeAudio.play('uniqueId2').then(() => {
    }, () => {
    });
    setTimeout(() => {
      this.nativeAudio.stop('uniqueId2').then(() => {
      }, () => {
      });
      this.alert.showAlert("播放");
    }, 3000);

  }

  //开奖号码提示
  //TQQ 2017-02-25
  public createNumMp3(opennum: string) {
    let url = "assets/mp3/sound/";
    let mp3 = new Audio(url + "open.wav");
    mp3.play();
    mp3.remove();
    let nums = opennum.split(",");
    let i = 0;
    let intervalId = setTimeout((s) => {
      let id = setInterval(() => {
        mp3 = new Audio(url + "m_" + parseInt(nums[i]) + ".wav");
        mp3.play();
        mp3.remove();
        i++;
        if (i == nums.length) {
          clearInterval(id);
        }
      }, 600);
      clearTimeout(intervalId);
    }, 1800);





    // this.nativeAudio.play('uniqueId1').then(() => {
    // }, () => {
    // });
    // setTimeout(() => {
    //   this.nativeAudio.stop('uniqueId1').then(() => {

    //   }, () => {

    //   });
    // }, 3000);
  }

  /** 浏览器新页面打开链接
  * @param isSafari 为 true 时，强制使用safari打开
  */
  public openUrl(url: string, isSafari = false) {
    const httpsUrl = url.replace(/^http:\/\//i, 'https://');
    const isPWA = ('standalone' in window.navigator) && ((<any>window.navigator).standalone);
    if (/iPad|iPhone|iPod/.test(navigator.userAgent)) {  // ios设备
      // 优先尝试 x-safari- 协议
      if (isPWA || isSafari) {
        window.location.href = `x-safari-${httpsUrl}`;
      } else {
        this.iab.create(url, "_system");
      }
    } else {
      this.iab.create(url, "_system");
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/app.config.ts